import { useEffect, useState } from "react";

const SCRIPT_SRC = "https://d2toxav8qvoos4.cloudfront.net/latest/wheelbase-widget.js";

function isDefined(tag: string): boolean {
  return typeof customElements !== "undefined" && Boolean(customElements.get(tag));
}

function ensureScript(): void {
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
    return;
  }
  const script = document.createElement("script");
  script.type = "module";
  script.src = SCRIPT_SRC;
  document.head.appendChild(script);
}

/** Loads the Wheelbase web components once for the SPA. Do not remove the script on unmount. */
export function useWheelbaseComponents(tag = "listing-details"): boolean {
  const [loaded, setLoaded] = useState(() => isDefined(tag));

  useEffect(() => {
    if (isDefined(tag)) {
      setLoaded(true);
      return;
    }
    ensureScript();
    let cancelled = false;
    void customElements.whenDefined(tag).then(() => {
      if (!cancelled) {
        setLoaded(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [tag]);

  return loaded;
}
